import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * Stock line (blocks/stock-info.liquid) on the product page: follows the selected variant.
 * The variant picker fetches the section for the new variant; the matching block is morphed in,
 * as product-inventory.js does for the theme's own inventory block. Product cards are left alone.
 */
class SiStockInfo extends HTMLElement {
  connectedCallback() {
    if (this.closest('product-card')) return;
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.onSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.onSelect);
  }

  /** @param {any} event */
  onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      ?.then(({ detail }) => {
        const next = detail?.html?.querySelector(`si-stock-info[data-block-id="${this.dataset.blockId}"]`);
        if (next) morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[si-stock-info]', error);
      });
  };
}

if (!customElements.get('si-stock-info')) customElements.define('si-stock-info', SiStockInfo);
